<template>
  <section>
    <h1 class="subtitle has-text-weight-bold has-text-primary is-size-4">
      Dados Básicos
    </h1>
    <div class="columns">
      <div class="column is-2">
        <sc-field label="Cep Origem" prop="origin_zip_code">
          <sc-input @keyup.native="changZipCode(fields.origin_zip_code)" v-model="fields.origin_zip_code" placeholder="Digite o cep de origem" v-mask="'cep'" />
        </sc-field>
      </div>
      <div class="column is-2">
        <sc-field label="Cep Destino" prop="destination_zip_code">
          <sc-input placeholder="Digite o cep de destino" v-model="fields.destination_zip_code" v-mask="'cep'" />
        </sc-field>
      </div>
      <div class="column is-8">
        <sc-field label="Tipo de Cotação">
          Entrega
          <sc-switch 
            :value="status"
            @input="toggleCommit"/>
          Reversa
        </sc-field>
      </div>
    </div>
    <div>
      <sc-additional-information :fields="fields" />
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  ScInput,
  ScSwitch,
  ScField,
} from '@intelipost-js/secure-components';
import ScAdditionalInformation from '../sc-additional-information/ScAdditionalInformation';

const {
  mapActions,
  mapState,
  mapMutations,
} = createNamespacedHelpers('quote/freightQuote');

export default {
  name: 'sc-basic-data',
  props: {
    fields: Object,
  },
  computed: {
    ...mapState([
      'shipment_type',
      'delivery_method_list',
    ]),
    status() {
      return this.shipment_type;
    },
  },
  components: {
    ScInput,
    ScField,
    ScSwitch,
    ScAdditionalInformation,
  },
  methods: {
    ...mapActions([
      'quoteGetLogistics',
    ]),
    ...mapMutations([
      'setDeliveryMethodList',
      'setShipmentTypeMode',
    ]),
    changZipCode() {
      if (this.fields.origin_zip_code && this.fields.origin_zip_code.replace('-', '').length === 8) {
        this.getDeliveryMethods();
      } else {
        this.fields.contracts = [];
        this.setDeliveryMethodList(this.fields.contracts);
      }
    },
    toggleCommit(event) {
      this.setShipmentTypeMode(event);
    },
    getDeliveryMethods() {
      this.quoteGetLogistics({
        origin_zip_code: this.fields.origin_zip_code,
        shipment_type: this.shipment_type,
      });
    },
  },
  mounted() {
    this.changZipCode();
  },
};
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-basic-data/ScBasicData.vue